//import GoogleMapsAPI from "../gutenberg/blocks/location-finder/modules/GoogleMapsAPI";



jQuery(document).ready(function ($) {

	/* -------------------------------------------------------------------------- */
	/* Trap focus for modals                                                      */
	/* -------------------------------------------------------------------------- */
	function trapFocus(event) {
		var $focusableElements = $('.focus-trap').find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
		var firstFocusableElement = $focusableElements.first();
		var lastFocusableElement = $focusableElements.last();
		var keyCode = event.keyCode;
	
		if (keyCode === 9) {
			// If the shift key is pressed, move focus to the last focusable element
			if (event.shiftKey && document.activeElement === firstFocusableElement[0]) {
				event.preventDefault();
				lastFocusableElement.focus();
			}
			// If the shift key is not pressed, move focus to the first focusable element
			else if (!event.shiftKey && document.activeElement === lastFocusableElement[0]) {
				event.preventDefault();
				firstFocusableElement.focus();
			}
		}
	}
	
	/* -------------------------------------------------------------------------- */
	/* Open/Close Function						                                  */
	/* -------------------------------------------------------------------------- */
	function openModal(element){
		// Add class to open menu and focus trap
		$(element).addClass('is-open focus-trap');
		// Call toggleTrapFocus function on and off
		$(document).on('keydown', trapFocus);
	}
	function closeModal(element){
		// Add class to open menu and focus trap
		$(element).removeClass('is-open focus-trap');
		// Call toggleTrapFocus function on and off
		$(document).off('keydown', trapFocus);
	}

	/* -------------------------------------------------------------------------- */
	/*  Submenu Toggle							                                  */
	/* -------------------------------------------------------------------------- */
	$('.sub-menu-toggle').on('click', function(event) {
		// Close all submenus at the same level
		$(this).parent().siblings().find('.sub-menu').removeClass('is-open');
		$(this).parent().siblings().find('.mega-menu').removeClass('is-open');
		$(this).parent().siblings().find('.mega-sub-menu').removeClass('is-open');
		$(this).parent().siblings().find('.sub-menu-toggle').attr('aria-expanded', 'false');

		// Toggle class to submenu to open
		$(this).next('.sub-menu').toggleClass('is-open');
		$(this).next('.mega-menu').toggleClass('is-open');
		$(this).next('.mega-sub-menu').toggleClass('is-open');

		// Get button's aria attribute
		var button = $(this);
		var currentAriaLabel = button.attr('aria-expanded');

		// Toggle between two labels
		var newAriaLabel = (currentAriaLabel === 'true') ? 'false' : 'true';

		// Update the aria-label attribute
		button.attr('aria-expanded', newAriaLabel);
		//Prevent the click event from reaching the document
		event.stopPropagation();
	});


	/* -------------------------------------------------------------------------- */
	/* Mobile Menu							                                      */
	/* -------------------------------------------------------------------------- */
	// Event listener for opening mobile menu (menu toggle button)
	$('.menu-toggle').on('click', function(event) {
		// Open mobile menu
		openModal('.mobile-nav');
		// Focus on active menu item on open
		$('.close-navigation').focus();
		// Prevent the click event from reaching the document
		event.stopPropagation();
	});
	// Event listener for closing the mobile menu (close menu button)
	$('.close-navigation').on('click', function() {
		// Close mobile menu
		closeModal('.mobile-nav');
		// Focus back on on mobile menu toggle when close
		$('.menu-toggle').focus();
	});
	
	
	/* -------------------------------------------------------------------------- */
	/* Close Modules on Document Click					  						  */
	/* -------------------------------------------------------------------------- */
	$(document).on('click', function(event) {
		// Check if the click is outside Main navigation submenu
		if (!$(event.target).closest('.main-navigation').length) {
			$('.main-navigation .sub-menu').removeClass('is-open');
			$('.main-navigation .mega-menu').removeClass('is-open');
			$('.main-navigation .mega-sub-menu').removeClass('is-open');
			$('.sub-menu-toggle').attr('aria-expanded', 'false');
		}
		// Check if the click is outside Mobile navigation
		if (!$(event.target).closest('.mobile-nav').length) {
			closeModal('.mobile-nav');
		}
	});
	
	
	/* -------------------------------------------------------------------------- */
	/* Esc Key Event															  */
	/* -------------------------------------------------------------------------- */
	// Define the modals and their trigger buttons
	var modals = [
		{ modalClass: '.mobile-nav', buttonSelector: '.menu-toggle' },
		{ modalClass: '.mega-menu', buttonSelector: '#toggle-button-mega-menu' }
	];
	
	// Add the sub-menus separately
	$(document).on('keydown', function(event) {
		// Handle other modals first
		modals.forEach(function (modal) {
			var $modal = $(modal.modalClass);
			// If modal has the class is-open and esc key is pressed
			if ($modal.hasClass('is-open') && event.keyCode === 27) {
				// Close modal
				closeModal(modal.modalClass);
				// Focus back to its trigger button
				$(modal.buttonSelector).attr('aria-expanded', 'false');
				$(modal.buttonSelector).focus();
			}
		});
	
		// Handle sub-menus separately
		if (event.keyCode === 27) {  // esc key pressed
			$('.sub-menu.is-open').each(function() {
				var $submenu = $(this);
				// Close the submenu
				$submenu.removeClass('is-open');
				// Find the closest trigger button
				var $triggerButton = $submenu.closest('li').find('.sub-menu-toggle');
				// Set focus back to its trigger button
				$triggerButton.attr('aria-expanded', 'false');
				$triggerButton.focus();
			});
		}
	});


	
	/* -------------------------------------------------------------------------- */
	/* Fancybox													                  */
	/* -------------------------------------------------------------------------- */
	//Fancybox.bind('[data-fancybox]');
	
	
	/* -------------------------------------------------------------------------- */
	/* Parallax													                  */
	/* -------------------------------------------------------------------------- */
	/*
	if( $('.has-parallax-img').length > 0 ) {
		$('.has-parallax-img').jarallax({
			speed: .5,
			imgElement: 'img',
			disableParallax: /iPad|iPhone|iPod|Android/
		});
	}
	*/
	
	
});






/* -------------------------------------------------------------------------- */
/*                         Init Follower CTA Listener                         */
/* -------------------------------------------------------------------------- */
const followingCTA = document.querySelector(".following-cta");
const topBarHeight = 133;

if (followingCTA) {
  window.addEventListener("scroll", () => {
	// window scroll listener
	if (window.scrollY >= topBarHeight) {
	  followingCTA.classList.add("following-cta--show");
	} else {
	  followingCTA.classList.remove("following-cta--show");
	}
  });
}

/* -------------------------------------------------------------------------- */
/*                          Auto Populate Form Fields                         */
/* -------------------------------------------------------------------------- */
(async () => {
  const zipInput = document.querySelector("#input_1_6");
  const stateInput = document.querySelector("#input_1_5");
  const storedLocation = localStorage.getItem("location");

  if (storedLocation && (zipInput || stateInput)) {
	const { latitude: lat, longitude: lng } = JSON.parse(storedLocation);
	// geocode location
	const { apiKey } = window.MAP;

	const res = await fetch(
	  `https://maps.googleapis.com/maps/api/geocode/json?key=${apiKey}&latlng=${lat},${lng}&result_type=postal_code`
	);

	if (res.status === "ZERO_RESULTS") return;

	let data = await res.json();

	if (zipInput) {
	  zipInput.value = data.results[0].address_components[0].long_name;
	}

	if (stateInput) {
	  stateInput.value = data.results[0].address_components[3].long_name;
	}
  }
})();
